import { useAppSelector } from "../../hook/store";
import { ESliceAuth } from '../../store/slices/authSlice'
import { ERouteKey } from '../../compiler/route.enum';
import { Navigate, useLocation } from "react-router-dom";
import { getFlatRoute } from "../routeTool";


const NoAuth = ({ children }: { children: JSX.Element }) => {
    const { company_uuid } = useAppSelector(state => state[ESliceAuth.AuthInfo])
    let location = useLocation()

    if (company_uuid) return <Navigate to={'/' + getFlatRoute()[ERouteKey.WELCOME]?.path} state={{ from: location }} replace />;

    return children
}


export default NoAuth
